export function isValidToken(token) {
  return typeof token !== 'undefined' && token !== null && token !== '';
}
